import styled from 'styled-components';
import { Button, Theme } from '@120wateraudit/waterworks';

const PrimaryButton = styled(Button)`
  background-color: ${Theme.palette.primary} !important;
  color: ${Theme.palette.neutral900} !important;
  border-color: transparent !important;
`;

export default PrimaryButton;
